import { Box, Button, Card, CardHeader, Chip, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, Grid, InputLabel, MenuItem, Modal, Select, SelectChangeEvent, Stack, Tab, Tabs, TextField, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Header from '../../../components/dashboard/Header'
import { useBeforeUnload, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import { useDispatch, useSelector } from 'react-redux';
import { t } from 'i18next';
import { DateTimePicker } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { useTracks } from '../../../hooks/useTracks';
import { get, isEmpty, lowerCase, toNumber, uniqBy } from 'lodash';
import { RootState } from '../../../store';
import { TUser } from '../../../shared/types/user.type';
import { useHorses } from '../../../hooks/useHorses';
import { Add, ArrowBack, Build, ContactMail } from '@mui/icons-material';
import NewChannelStepper from '../../../components/notifications/NewChannelStepper';
import NewConfigurationStepper from '../../../components/notifications/NewConfigurationStepper';
import { useNotificationsSettings } from '../../../hooks/useNotificationSettings';
import Channels from '../../../components/notifications/Channels';
import Configurations from '../../../components/notifications/Configurations';
import { toast } from 'react-toastify';
import { useQueryClient } from 'react-query';
import { TChannel, TChannelType } from '../../../shared/types/Channel.type';
import { TSchedule } from '../../../shared/types/schedule.type';
import axiosInstance from '../../../api/base';
import i18n from '../../../locales';
import BaseModal from '../../../components/modals/BaseModal';
import ChooseBuild from '../../../components/notifications/ChooseBuild';
import { useGallopData } from '../../../hooks/useGallopData';
import { LoadingButton } from '@mui/lab';

export type RepportType = 'TRAINING_REPORT' | 'GALLOP_REPPORT' | 'STABLE_REPPORT'

function Notifications({ standalone }: { standalone?: boolean }) {

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const [value, setValue] = React.useState('0');

    let [searchParams, setSearchParams] = useSearchParams();

    const [open, setOpen] = useState(false);
    const [pendingDeleteId, setPendingDeleteId] = useState<number | null>(null); // Optional, if you delete by id

    const [channelToEdit, setChannelToEdit] = useState<TChannel | null>(null)
    const [configToEdit, setConfigToEdit] = useState<TSchedule | null>(null)
    const [newConfigModal, setNewConfigModal] = useState(false)
    const [recipientModal, setRecipientModal] = useState(false)
    const [newChannelModal, setNewChannelModal] = useState(false)
    const [newConfigurationModal, setNewConfigurationModal] = useState(false)
    const [configType, setConfigType] = useState<'SIMPLE' | 'ADVANCED' | undefined>(undefined)
    const [cnt, setContinue] = useState(true)

    const [horseSearch, setHorseSearch] = useState('')
    const [repportType, setRepportType] = useState<RepportType>('TRAINING_REPORT')
    //Hooks
    const user = useSelector<RootState>(state => state.user.user) as TUser
    const { isUserFetching, auth, isAdmin } = useAuth()
    const { tracks, trainingTypes, isLoading, isLoadingTrainingTypes } = useTracks(cnt && !isUserFetching && !isEmpty(user), auth?.id, true, true)
    const { horses, isLoadingHorses } = useHorses(!isUserFetching && !isEmpty(horseSearch), auth?.['@id'], {
        horses: {
            ...(horseSearch ? { 'horse.name': horseSearch } : {})

        }
    })
    const { channels, channelsLoading, configs, configsLoading, deleteChannel, deleteWhatsappChannel, triggerStableSend, deleteWhatsappGroupChannel, deleteConfig, saveChannel, saveConfig, saveStable, gallops, updateConfig, triggerGallopSend, triggerTrainingSend, stables, deleteStable, updateStable } = useNotificationsSettings(cnt && !isUserFetching && !isEmpty(user), auth?.['@id'])
    const { deleteGallopReview, saveGallopReview, updateGallopReview } = useGallopData({ gallopDataQueryEnabled: false })
    const dataLoading = isLoading || isLoadingTrainingTypes

    //
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // Check if screen is small


    //
    const [selectedOption, setSelectedOption] = useState<'channel' | 'config' | undefined>(undefined)

    //Getting Query Params from header
    const TOKEN = searchParams.get('token')
    const LANG = searchParams.get('lang')
    //


    const tabs = [
        {
            title: "repportType:training",
            index: '0',
        },
        {
            title: "repportType:gallop",
            index: '1',
        },
       {
            title: "repportType:stable",
            index: '2',
        }

    ]

    const queryClient = useQueryClient()




    useEffect(() => {
        if (LANG && standalone && cnt) {
            i18n.changeLanguage(lowerCase(LANG))
        }
    }, [LANG, standalone, cnt])


    const deleteSelectedChannel = async (id: number, channelType: TChannelType) => {
        try {
            switch (channelType) {
                case 'EmailCommunicationChannel':
                    await deleteChannel.mutateAsync(id);
                    break;
                case 'WhatsappCommunicationChannel':
                    await deleteWhatsappChannel.mutateAsync(id)
                    break;
                case 'WhatsappGroupCommunicationChannel':
                    await deleteWhatsappGroupChannel.mutateAsync(id)
                    break;
                default:
                    break;
            }
            toast(t('rights:success'), { type: 'success' })
            queryClient.refetchQueries(['channels'])
        } catch (error) {
            toast(t('error:generic'), { type: 'error' })

        }
    }

    const handleDeleteClick = (id: number, type?: string) => {
        setPendingDeleteId(id); // Optional
        setOpen(true);
    };

    const toggleConfig = async (id: number, active: boolean) => {

        let promise = null
        switch (repportType) {
            case 'GALLOP_REPPORT':
                promise = updateGallopReview
                break;
            case 'TRAINING_REPORT':
                promise = updateConfig
                break;
            case 'STABLE_REPPORT':
                promise = updateStable
                break;
            default:
                throw new Error('Type not found', repportType)
        }

        await promise.mutateAsync({ id: id, config: { active } })
            .then(result => {
                toast(t('rights:success'), { type: 'success' })
                queryClient.refetchQueries(['configs'])
                queryClient.refetchQueries(['gallops'])
                queryClient.refetchQueries(['stables'])
            }).catch(err => {
                toast(t('error:generic'), { type: 'error' })

            })
    }

    const handleConfirmDelete = () => {
        if (!pendingDeleteId) return
        deleteSelectedConfig(pendingDeleteId); // or just deleteSelectedConfig() if no id needed
        setOpen(false);
    };

    const handleCancel = () => {
        setOpen(false);
        setPendingDeleteId(null);
    };



    const deleteSelectedConfig = async (id: number) => {
        let promise = null
        switch (repportType) {
            case 'GALLOP_REPPORT':
                promise = deleteGallopReview
                break;
            case 'TRAINING_REPORT':
                promise = deleteConfig
                break;
            case 'STABLE_REPPORT':
                promise = deleteStable
                break;
            default:
                throw new Error('Type not found', repportType)
        }
        try {
            await promise.mutateAsync(id)
            toast(t('rights:success'), { type: 'success' })
            queryClient.refetchQueries(['configs'])
            queryClient.refetchQueries(['gallops'])
            queryClient.refetchQueries(['stables'])

        } catch (error) {
            toast(t('error:generic'), { type: 'error' })

        }
    }

    const duplicateChannel = ({ name,
        targets,
        lang,
        unit_system,
        speed_unit }: TChannel) => {
        let dataObj = {
            name: name + ' copy',
            targets,
            lang,
            unit_system,
            speed_unit,
            user: user['@id']
        }

        saveChannel.mutateAsync(dataObj).then((result) => {
            //TODO: back and refetch
            toast(t('rights:success'), { type: 'success' })
            setChannelToEdit(result.data)
            setSelectedOption('channel')
            queryClient.refetchQueries(['channels'])
        }).catch(err => {
            toast(t('error:generic'), { type: 'error' })

        })

    }


    const duplicateConfig = ({ communication_channels, horse_ages, max_best600, name, track_names, training_types, horses, schedules, active, max_splits_distance = 800 }: TSchedule) => {
        let dataObj: any = {
            communication_channels: communication_channels.map(channel => get(channel, '@id')),
            name: name + ' copy',
            horse_ages,
            max_best600,
            ...(repportType === 'GALLOP_REPPORT' ? { max_splits_distance } : {}),
            track_names: track_names.map(track => get(track, '@id')),
            training_types: training_types.map(tr => get(tr, '@id')),
            horses: horses.map(h => get(h, '@id')),
            schedules: [
                {
                    "type": get(schedules, '[0].type'),
                    "timezone": get(schedules, '[0].timezone'),
                    "day_of_week": get(schedules, '[0].day_of_week'),
                    "hour": get(schedules, '[0].hour', undefined),
                    "minute": get(schedules, '[0].minute', undefined)
                }
            ],
            active,
            user: user?.['@id']
        }

        let promise = null
        switch (repportType) {
            case 'GALLOP_REPPORT':
                promise = saveGallopReview
                break;
            case 'TRAINING_REPORT':
                promise = saveConfig
                break;
            case 'STABLE_REPPORT':
                promise = saveStable
                break;
            default:
                throw new Error('Type not found', repportType)
        }



        promise.mutateAsync(dataObj).then((result) => {
            toast(t('rights:success'), { type: 'success' })
            setConfigToEdit(result.data)
            setSelectedOption('config')
            queryClient.refetchQueries(['configs'])
            queryClient.refetchQueries(['gallops'])
            queryClient.refetchQueries(['stables'])
        }).catch(err => {
            toast(t('error:generic'), { type: 'error' })

        })


    }

    //set Title
    const getTitle = () => {
        let find = tabs.find(tab => tab.index === value)
        if (!find) return ""
        return t(find.title)
    }

    const triggerSend = (id: number, dates: string[]) => {

        let dateDto = {
            start_date: dates[0],
            end_date: dates[1],
        }

        let promise = null
        switch (repportType) {
            case 'GALLOP_REPPORT':
                promise = triggerGallopSend
                break;
            case 'TRAINING_REPORT':
                promise = triggerTrainingSend
                break;
            case 'STABLE_REPPORT':
                promise = triggerStableSend
                break;
            default:
                throw new Error('Type not found', repportType)
        }



        promise.mutateAsync({ id, dates: dateDto }).then((result: any) => {
            toast(t('trigger:success'), { type: 'success' })
        }).catch((err: Error) => {
            toast(t('error:generic'), { type: 'error' })

        })

    }

    //Handle tabs Click
    const onTabChange = (value: string) => {
        setValue(value)

        let find = tabs.find(tab => tab.index === value)

        if (!find) return

        switch (find.index) {
            case '0':
                setRepportType('TRAINING_REPORT')
                break;
            case '1':
                setRepportType('GALLOP_REPPORT')
                break;
            case '2':
                setRepportType('STABLE_REPPORT')
                break;
            default:
                setRepportType('TRAINING_REPORT')
                break;
        }

    }

    const getData = () => {
        switch (repportType) {
            case 'GALLOP_REPPORT':
                return gallops
            case 'TRAINING_REPORT':
                return configs
            case 'STABLE_REPPORT':
                return stables
            default:
                return []
        }
    }

    return (
        <Box
            sx={{ display: 'flex', height: '100%', minHeight: '70vh', flexDirection: isSmallScreen ? 'column' : 'row' }}
        >
            <Tabs
                orientation={isSmallScreen ? 'horizontal' : "vertical"}
                variant="scrollable"
                scrollButtons='auto'
                value={value}
                onChange={(_, value) => onTabChange(value)}
                sx={{ borderRight: 1, borderColor: 'divider', borderRadius: 0 }}
            >
                {tabs.map((tab, i) => (
                    <Tab key={tab.index} label={<Typography variant='subtitle2' >{t(tab.title)}</Typography>} value={tab.index} />
                ))}
            </Tabs>

            <Container maxWidth={standalone ? "lg" : 'xl'} sx={{ height: '100vh', p: 3, bgcolor: 'background.paper', overflowX: 'hidden' }}>
                < >
                    <Box>
                        <Typography variant='h6'>{getTitle()}</Typography>
                        <Box mt={1} display={'flex'} gap={1}>
                            <Button onClick={() => setNewConfigModal(true)} variant='contained'>{t('button:addNewConfig')}</Button>
                            <Button onClick={() => setRecipientModal(true)} variant='outlined'>{t('notification:channel')}</Button>
                        </Box>
                    </Box>
                    <Divider sx={{ my: 1 }}></Divider>
                    <Configurations
                        onDuplicate={duplicateConfig}
                        onEdit={(item) => {
                            setConfigToEdit(item)
                            setConfigType('ADVANCED')
                            setSelectedOption('config')
                            setNewConfigurationModal(true)
                        }}
                        triggerSend={triggerSend}
                        onDelete={handleDeleteClick}
                        isDeleting={deleteConfig.isLoading}
                        configs={getData()}
                        isTriggering={triggerTrainingSend.isLoading || triggerGallopSend.isLoading || triggerStableSend.isLoading}
                        toggleEnabled={toggleConfig}
                        loading={configsLoading}></Configurations>
                </>

                {/* Modals */}
                <BaseModal
                    open={newConfigModal}
                    width={matches ? '50%' : '320px'}
                    handleClose={() => setNewConfigModal(false)}
                    title='button:addNewConfig'
                >
                    <ChooseBuild createNewConfig={(value) => {
                        setConfigType(value)
                        setNewConfigModal(false)
                        setNewConfigurationModal(true)
                    }}></ChooseBuild>

                </BaseModal>


                {/* Channel View Modal */}
                <BaseModal
                    open={recipientModal}
                    width={matches ? '70%' : '320px'}
                    handleClose={() => {
                        setChannelToEdit(null)
                        setRecipientModal(false)
                    }}
                    title={t('notification:channel')}
                >
                    <Channels
                        createNewChannel={() => {
                            setChannelToEdit(null)
                            setNewChannelModal(true)
                        }}
                        onDuplicate={duplicateChannel}
                        onEdit={(item) => {
                            setChannelToEdit(item)
                            setNewChannelModal(true)
                        }} isDeleting={deleteChannel.isLoading || deleteWhatsappChannel.isLoading}
                        onDelete={deleteSelectedChannel}
                        channels={channels}
                        loading={channelsLoading}></Channels>
                </BaseModal>

                {/* Channel Creation Modal */}

                <BaseModal
                    open={newChannelModal}
                    handleClose={() => {
                        setChannelToEdit(null)
                        setNewChannelModal(false)
                    }}
                    title={channelToEdit ? t('channel:editList') : t('channel:createNewList')}
                    width={matches ? '50%' : '320px'}
                >
                    <NewChannelStepper itemToEdit={channelToEdit} onSaveSuccess={() => {
                        setChannelToEdit(null)
                        setSelectedOption(undefined)
                        setNewChannelModal(false)
                    }}></NewChannelStepper>
                </BaseModal>


                {/* Create a new configuration Modal */}
                <BaseModal
                    open={newConfigurationModal}
                    handleClose={() => {
                        setConfigToEdit(null)
                        setNewConfigurationModal(false)
                    }}
                    title={configToEdit ? t('configuration:edit') : configType === 'SIMPLE' ? t('configuration:buildSimple') : t('configuration:buildAdvanced')}
                    width={matches ? '70%' : '320px'}
                >
                    <NewConfigurationStepper
                        repportType={repportType}
                        configType={configType}
                        onInputChange={searchValue => setHorseSearch(searchValue)}
                        createNewChannel={() => {
                            setChannelToEdit(null)
                            setNewChannelModal(true)
                        }}
                        editChannel={(item) => {
                            setChannelToEdit(item)
                            setNewChannelModal(true)
                        }}
                        deleteChannel={deleteSelectedChannel}
                        dataLoading={dataLoading}
                        isLoading={channelsLoading}
                        isDeleting={deleteChannel.isLoading || deleteWhatsappChannel.isLoading}
                        itemToEdit={configToEdit}
                        onSaveSuccess={() => {
                            queryClient.refetchQueries(['configs'])
                            queryClient.refetchQueries(['gallops'])
                            queryClient.refetchQueries(['stables'])
                            setNewConfigurationModal(false)
                        }}
                        horses={horses}
                        tracks={tracks}
                        trainingTypes={trainingTypes}
                        horsesLoading={isLoadingHorses}
                        channels={channels}></NewConfigurationStepper>
                </BaseModal>

                <Dialog open={open} onClose={handleCancel}>
                    <DialogTitle>{t('confirmDeletion')}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {t('deleteConfigMessage')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCancel}>{t('alert.cancel')}</Button>
                        <LoadingButton loading={deleteConfig.isLoading} onClick={handleConfirmDelete} color="error" variant="contained">
                            {t('shareVetModale:confirm')}
                        </LoadingButton>
                    </DialogActions>
                </Dialog>
            </Container >
        </Box>
    )
}
Notifications.defailtProps = {
    standalone: false
}
export default Notifications